import React from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import DeleteAccountPopup from "../deleteAccount/DeleteAccountPopup";
import styles from './MoreVertical.module.scss';  // added by Bearer Web Developer
// import ChangePasswordPopup from "./changePasswordPopup"; // added and later removed for individual by Bearer Web Developer
import { analytics } from "../../api/bearer-api"; // added by Bearer Web Developer
import { logEvent } from "firebase/analytics"; // added by Bearer Web Developer
import {  observer } from "mobx-react-lite"; // added by Bearer Web Developer
import { useAppState } from "../../states/app-state"; // added by Bearer Web Developer

const MoreVertical: React.FC = observer(() => { // observer added by Bearer Web Developer
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };


    const appState = useAppState(); // added by Bearer Web Developer
    const { deleteAccount } = appState; // added by Bearer Web Developer
    // const [deleteAccountOpen, setDeleteAccountOpen] = React.useState(false); commented and change use state to mobex state by Bearer Web Developer
    const handleDeleteAccount = () => {
        // added by Bearer Web Developer start
        // Firebase Analytics Event Name Delete Account Request
        // App Event Delete Account Clicked
        logEvent(analytics,"delete_account_requested");
        // added by Bearer Web Developer end
        deleteAccount.setOpen(true); // modified (change use state to mobex state) by Bearer Web Developer
    }
    // handleDeleteAccountClose function removed by Bearer Web Developer
    // added and later removed for individual by Bearer Web Developer start
    // const [changePasswordOpen, setChangePasswordOpen] = React.useState(false);
    // const handleChangePassword = () => {
    //     setChangePasswordOpen(true);
    // }
    // const handleChangePasswordClose = () => {
    //     setChangePasswordOpen(false);
    // }
    // added and later removed for individual by Bearer Web Developer end
    return (<>
        <DeleteAccountPopup /> {/* props of DeleteAccountPopup removed for individual by Bearer Web Developer */} 
        {/* <ChangePasswordPopup open={changePasswordOpen} handleClose={handleChangePasswordClose} /> */} {/* added and later removed for individual by Bearer Web Developer */}
        {/* modified by Bearer Web Developer start */}
        <Button onClick={handleMenu} className={styles.more_datails}>
            <span>More Actions</span> <img src={`/expand_more_black.png`} className={open ? styles.rotate :""}  />
        </Button>
        {/* modified by Bearer Web Developer end */}
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            anchorReference="anchorEl"
            open={open}
            onClose={handleClose}
            className={styles.more_datails_menu}
            classes={{
                paper: styles.more_datails_menu_paper
            }}
        >
            <MenuItem className={styles.delete_account} onClick={handleDeleteAccount}><span>Delete Account</span></MenuItem>
            {/* <MenuItem onClick={handleChangePassword}>Change Password</MenuItem> */} {/* added and later removed for individual by Bearer Web Developer */}
        </Menu>
    </>
    );
});
export default MoreVertical;